'use strict';

import React, { Component, createRef } from 'react'

import PropTypes from 'prop-types'

import { v4 as uniqid } from 'uuid'

import Button from '@material-ui/core/Button'

import bemit from '@function/bemit'

const MIN_DISTANCE = 50;

export default class Slider extends Component
{
	state =
	{
		active_element: this.props.type === 'custom'
		? this.props.elements[0]
		: this.props.images[0],

		translate: 0,
		ready: false,

		id: uniqid(),

		modal: false,

		auto_direction: 'next'
	};

	ref = createRef();

	refresh_time = 300;

	componentDidMount ()
	{
		const component = this, props = this.props, state = this.state;

		if (state.active_element)
		{
			component.init();
		}
		else
		{
			component.setState(
			{
				active_element: props.type === 'custom'
				? props.elements[0]
				: props.images[0]
			});
		}
	}

	init = () =>
	{
		const component = this, props = this.props, state = this.state;

	// Update slider width in case of slider width change
		component.setRefresh();

		window.addEventListener('resize', component.setRefresh);

		if (props.auto === true)
		{
			component.setAuto();
		}
	}

	componentDidUpdate (prev_props, prev_state)
	{
		const component = this, props = this.props, state = this.state;

		if (prev_state.ready !== true && state.ready === true)
		{
			if (typeof props.onReady === 'function')
			{
				window.requestAnimationFrame(props.onReady);
			}
		}
		else if (!state.active_element && (props.elements || props.images || [])[0])
		{
			component.setState(
			{
				active_element: (props.elements || props.images || [])[0]
			});
		}
		else if (!prev_state.active_element && state.active_element)
		{
			component.init();
		}
	}

	slideAuto = () =>
	{
		const component = this, props = this.props, state = this.state;

		if (state.auto_direction === 'next')
		{
			component.next();
		}
		else
		{
			component.previous();
		}

		component.setAuto();
	}

	setAuto = () =>
	{
		const component = this, props = this.props, state = this.state;

		component.auto_timeout = window.setTimeout(function ()
		{
			component.auto_timeout = undefined;

			component.slideAuto();
		},
		props['auto-timing'] || 8000);
	}

	componentWillUnmount ()
	{
		const component = this, props = this.props, state = this.state;

		window.removeEventListener('resize', component.setRefresh);

		if (component.auto_timeout )
		{
			window.clearTimeout(component.auto_timeout);
		}
	}

	setRefresh = (e) =>
	{
		const component = this, props = this.props, state = this.state;

		if (component.check_timeout) window.clearTimeout(component.check_timeout);

		const slider = component.getSliderNode();

		if (!slider) // slider not loaded, try later
		{
			component.check_timeout = window
			.setTimeout(function ()
			{
				component.check_timeout = undefined;

				component.setRefresh();
			},
			component.refresh_time);

			return;
		}

		component.check_timeout = window.setTimeout(function ()
		{
			component.check_timeout = undefined;

			component.checkWidth();
		},
		component.refresh_time);
	}

	getSliderNode = () => document.getElementById(this.state.id);

	checkWidth = () =>
	{
		const component = this, props = this.props, state = this.state;

		if (component.check_timeout) window.clearTimeout(component.check_timeout);

		component.check_timeout = undefined;

		const width = component.getSliderNode()?.getBoundingClientRect?.()?.width;

		component.width = width || 0;

		component.setTranslate();

		if (width > 0 && !state.ready)
		{
			component.setState({ ready: true });
		}
	}

	setTranslate = (active_element) =>
	{
		const component = this, props = this.props, state = this.state;

		const elements = props.type === 'custom'
		? props.elements || []
		: props.images || [];

		const current_element = active_element || state.active_element;

		if (!current_element)
		{
			component.refresh = window.setTimeout(function ()
			{
				component.refresh = undefined;

				component.setTranslate();
			},
			300);

			return;
		}

		if (component.width > 0 === false)
		{
			component.setRefresh(null);

			return;
		}

		let offset = 0;

		if (current_element.id !== elements[0].id)
		{
			const index = elements
			.findIndex(el => el.id === current_element.id);

			offset = index * (component.width);
		}

		component.setState({ translate: offset });
	}

	next = (e) =>
	{
		const component = this, props = this.props, state = this.state;

		const manual = e === undefined ? false : true;

		const elements = props.type === 'custom'
		? props.elements || []
		: props.images || [];

		const index = elements
		.findIndex(el => el.id === state.active_element.id);

		if (index < elements.length - 1)
		{
			component.setState({ active_element: elements[index + 1] });

			component.setTranslate(elements[index + 1]);
		}

		if (index === elements.length - 2)
		{
			component.setState({ auto_direction: 'previous' });
		}
		else if (manual)
		{
			component.setState({ auto_direction: 'next' });
		}

		if (props.auto === true && component.auto_timeout)
		{
			window.clearTimeout(component.auto_timeout);

			component.setAuto();
		}
	}

	previous = (e) =>
	{
		const component = this, props = this.props, state = this.state;

		const manual = e === undefined ? false : true;

		const elements = props.type === 'custom'
		? props.elements || []
		: props.images || [];

		const index = elements
		.findIndex(el => el.id === state.active_element.id);

		if (index > 0)
		{
			component.setState({ active_element: elements[index - 1] });

			component.setTranslate(elements[index - 1]);
		}

		if (index === 1)
		{
			component.setState({ auto_direction: 'next' });
		}
		else if (manual)
		{
			component.setState({ auto_direction: 'previous' });
		}

		if (props.auto === true && component.auto_timeout)
		{
			window.clearTimeout(component.auto_timeout);

			component.setAuto();
		}
	}

	openModal = (e) =>
	{
		const component = this, props = this.props, state = this.state;

		component.setState(
		{
			modal: true,
			modal_trg: e?.target
		});
	}

	closeModal = (e) =>
	{
		const component = this, props = this.props, state = this.state;

		component.setState(
		{
			modal: false,
			modal_trg: undefined
		});
	}

	goTo = (e, element, i) =>
	{
		const component = this, props = this.props, state = this.state;

		component.setState({ active_element: element });

		component.setTranslate(element);
	}

	handleTouchStart = (e) =>
	{
		const component = this, props = this.props, state = this.state;

		const touch = e.touches?.[0];

		if (!touch) return;

		component.swipe = { x: touch.clientX };

		component.swiped = false;
	}

	handleTouchMove = (e) =>
	{
		const component = this, props = this.props, state = this.state;

		if (e.changedTouches?.length > 0)
		{
			component.swipe.swiping = true;
		}
	}

	handleTouchEnd = (e) =>
	{
		const component = this, props = this.props, state = this.state;

		const touch = e.changedTouches?.[0];

		if (!touch) return;

		const absX = Math.abs(touch.clientX - component.swipe.x);

		if (component.swipe.swiping && absX > MIN_DISTANCE)
		{
			const direction = touch.clientX < component.swipe.x
			? 'right'
			: 'left';

			component.swiped = true;

			if (direction === 'left')
			{
				component.previous();
			}
			else
			{
				component.next();
			}
		}

		component.swipe = { };
	}

	render ()
	{
		const component = this, props = this.props, state = this.state;

		const active_element = state.active_element;

		let modifiers = ['auto'].concat(props.bemit || []);

		const elements = props.type === 'custom'
		? props.elements || []
		: props.images || [];

		if (elements.length === 0) return null;

		if (active_element?.id === elements[0]?.id)
		{
			modifiers.push('first');
		}

		if (active_element?.id === elements[elements.length-1]?.id)
		{
			modifiers.push('last');
		}

		if (state.ready === true) modifiers.push('ready');

		let elements_list = [];

		const touch_events = props['with-overlay'] ? { } :
		{
			onTouchStart: component.handleTouchStart,
			onTouchMove: component.handleTouchMove,
			onTouchEnd: component.handleTouchEnd
		};

		if (props.type === 'custom')
		{
			elements_list = elements.map(function (element)
			{
				let output =
				(
					<div className="o-img-slider__element" key={ element.id }
						onTouchStart={ touch_events.onTouchStart }
						onTouchMove={ touch_events.onTouchMove }
						onTouchEnd={ touch_events.onTouchEnd }>
						{ element.content }
					</div>
				);

				return output;
			});
		}
		else
		{
			elements_list = elements.map(function (image)
			{
				const src = document.location.hostname === 'localhost'
				? 'https://appli.synergies.site' + image.src
				: image.src;

				let output =
				(
					<img className="o-img-slider__img" src={ src }
						alt={ image.alt } key={ image.id }
						id={ state.id + '-' + image.id }
						onTouchStart={ touch_events.onTouchStart }
						onTouchMove={ touch_events.onTouchMove }
						onTouchEnd={ touch_events.onTouchEnd }
					/>
				);

				return output;
			});
		}

		const styles =
		{
			transform: 'translateX(-' + state.translate + 'px)',
			width: component.width * elements.length + 'px'
		};

		const progress_controls = props['hide-progress'] === true
		? undefined
		: elements.map(function (element, i)
		{
			let class_name = 'o-img-slider__progress-control';

			if (element.id === active_element.id)
			{
				class_name += ' active';
			}

			const output =
			(
				<button type="button" className={ class_name } key={ element.id }
					onClick={ (e) => component.goTo(e, element, i) }>
					<span className="u-readers-only">Image n° { i }</span>
				</button>
			);

			return output;
		});

		const slider_events = props['with-overlay'] ?
		{
			onTouchStart: component.handleTouchStart,
			onTouchMove: component.handleTouchMove,
			onTouchEnd: component.handleTouchEnd
		}
		: { };

		let output =
		(
			<div id={ state.id }
				className={ bemit('o-img-slider', modifiers) }
				onTouchStart={ slider_events.onTouchStart }
				onTouchMove={ slider_events.onTouchMove }
				onTouchEnd={ slider_events.onTouchEnd }>

				{
					props.children ?
					(
						<div className="o-img-slider__custom-content"
							onTouchStart={ component.handleTouchStart }
							onTouchMove={ component.handleTouchMove }
							onTouchEnd={ component.handleTouchEnd }>
							{ props.children }
						</div>
					)
					: undefined
				}

				<div className="o-img-slider__translate"
					style={ styles }>

					{ elements_list }

				</div>

				{
					props['hide-arrows'] !== true ?
					(
						<Button className="o-img-slider__left"
							onClick={ component.previous }>
							<span className="u-readers-only">Précédent</span>
						</Button>
					)
					: undefined
				}

				{
					props['hide-arrows'] !== true ?
					(
						<Button className="o-img-slider__right"
							onClick={ component.next }>
							<span className="u-readers-only">Suivant</span>
						</Button>
					)
					: undefined
				}

				{
					progress_controls ?
					(
						<div className="o-img-slider__progress">
							{ progress_controls }
						</div>
					)
					: undefined
				}

			</div>
		);

		return output;
	}
}
